/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Placeholder_Generated2Inputs */

const id_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API dibuat`)
};

const ms_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API dijana`)
};

const da_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API nøgle genereret`)
};

const de_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel generiert`)
};

const en_us2_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key generated`)
};

const es_es2_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave de API generada`)
};

const es_mx2_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key generada`)
};

const fil_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-generate ang API key`)
};

const fr_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé API générée`)
};

const it_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave API generata`)
};

const hu_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs létrehozva`)
};

const nl_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel gegenereerd`)
};

const no_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkel generert`)
};

const pl_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygenerowano klucz API`)
};

const pt_br2_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key generated`)
};

const pt_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave de API gerada`)
};

const ro_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheie API generată`)
};

const fi_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avain luotu`)
};

const sv_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckel genererad`)
};

const vi_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo khóa API`)
};

const tr_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı oluşturuldu`)
};

const cs_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API klíč vygenerován`)
};

const bg_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API ключът е генериран`)
};

const ru_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ сгенерирован`)
};

const uk_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ згенеровано`)
};

const ar_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إنشاء مفتاح API`)
};

const hi_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी उत्पन्न`)
};

const th_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างคีย์ API แล้ว`)
};

const ja_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーを生成しました`)
};

const zh_cn2_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key generated`)
};

const zh_hant1_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key generated`)
};

const ko_components_apikeymanager_placeholder_generated2 = /** @type {(inputs: Components_Apikeymanager_Placeholder_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key generated`)
};

/**
* | output |
* | --- |
* | "API key generated" |
*
* @param {Components_Apikeymanager_Placeholder_Generated2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_placeholder_generated2 = /** @type {((inputs?: Components_Apikeymanager_Placeholder_Generated2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Placeholder_Generated2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "da") return da_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "de") return de_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "it") return it_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "no") return no_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "th") return th_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_placeholder_generated2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_placeholder_generated2(inputs)
	return ko_components_apikeymanager_placeholder_generated2(inputs)
});
export { components_apikeymanager_placeholder_generated2 as "components.apiKeyManager.placeholder.generated" }